<template>
    <div class="row" :class="{ 'moderator': adminMode }">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-12 col-sm-4">
                    <h1>{{ product.name }}</h1>
                </div>
                <div class="col-xs-12 col-sm-5">
                    <div class="alert alert-info" 
                            role="alert" 
                            v-if="admin" 
                            style="cursor:pointer;">
                        <div @click="toggleAdminMode" role="button">
                            {{ $_locale('client order mode') }}: <span>
                            <b v-if="!adminMode">{{ $_locale('on') }}</b>
                            <b v-if="adminMode">{{ $_locale('off') }}</b>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-3 datepicker-master">
                    <button class="btn btn-xs btn-default" @click="adjustDate(-1)">
                        <i class="glyphicon glyphicon-chevron-left"></i>
                    </button>
                    <input type="text" class="form-control" ref="dateInput" style="margin: 0 7px;" />
                    <button class="btn btn-xs btn-default" @click="adjustDate(1)">
                        <i class="glyphicon glyphicon-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-xs-12 reservation-product-description" 
            v-html="product.description">
        </div>
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-12 col-sm-6">
                    <div class=""
                        style="position: sticky;top: 15px;z-index: 10;margin-bottom: 15px;">
                        <div class="btn-group btn-group-sm" role="group" aria-label="Golf kentät">
                            <button 
                                type="button" 
                                class="btn btn-default"
                                :class="{ active: table.resourceId == selectedResource }"
                                v-for="(table, index) in timeTable" 
                                :key="index"
                                @click="selectedResource = table.resourceId;"
                            >{{ table.title }}</button>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <button class="btn btn-sm btn-default pull-right change-viewmode hidden" 
                        @click="$store.commit('golf/toggleViewMode')">
                        <i class="glyphicon" 
                           :class="{
                                'glyphicon-th': VIEW_MODES.grid != selectedViewMode,
                                'glyphicon-list': VIEW_MODES.grid == selectedViewMode,
                            }"></i>
                    </button>
                    <button class="btn btn-sm btn-default pull-right openuserteetimes"
                        style="margin-right: 7px;"
                        v-if="!adminMode"
                        @click="openGolfUserTeeTimes">
                        {{ $_locale('your golf tee times') }}
                    </button>
                    <button class="btn btn-sm btn-default pull-right openuserteetimes"
                        style="margin-right: 7px;"
                        v-if="adminMode"
                        @click="openAdminTeeTimes">
                        {{ $_locale('tee times') }}
                    </button>
                    <button class="btn btn-sm btn-default pull-right openuserteetimes"
                        style="margin-right: 7px;"
                        v-if="adminMode"
                        @click="$store.commit('common/setModal', 'resourcecommentmodal')">
                        {{ $_locale('comments') }}
                    </button>
                    <button class="btn btn-sm btn-default pull-right openuserteetimes"
                        :class="{
                            'active': showPast
                        }"
                        style="margin-right: 7px;"
                        v-if="!adminMode && isToday"
                        @click="showPast = !showPast">
                        {{ $_locale('show past tee times') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-xs-12">
            <div v-if="!isInvalidDate(date)"
                    class="golf-reservation-table" 
                    style="margin-bottom: 20px;padding-top: 7px;"
                    :class="{
                        'admin-mode': adminMode,
                        'show-past-teetimes': showPast
                    }">
                <div class="base" v-if="!disabled">
                    <div v-if="dateChangeInProgress" style="position:absolute;top:0;left:0;left: 60px;width: calc(100% - 60px);height:100%;min-height:450px;z-index: 10;">
                        <div class="spinner-master" style="">
                            <div style="">
                                <i class="glyphicon glyphicon-refresh spin"></i>
                            </div>
                        </div>
                    </div>
                    <div v-if="false">
                        <div class="time"
                            v-for="(time, index) in baseTimeTable" :key="index">
                            <span class="title">{{ $_formatDateTime($_dateFormat.DATETIME_HI, time.start) }}</span>
                        </div>
                    </div>
                    <div class="time-blocks">
                        <golf-table-column 
                            ref="golfTableColumn"
                            v-for="(table, index) in timeTableRows"
                            :key="index" 
                            :hidden="selectedResource != table.resourceId" 
                            :table="table">
                        </golf-table-column>
                    </div>
                </div>
            </div>
            <transition name="fadeInBottom">
                <golf-sticky-notes 
                    v-if="showStickyNotes" 
                    @deselect="onDeselectAll"
                    :resourceId="selectedResource" />
            </transition>
        </div>
        <golf-confirmation-modal />
        <edit-golf-reservation-modal />
        <golf-reservations-user-modal />
        <golf-admin-reservation-list-modal />
        <resource-comment-modal :resource="selectedTable" />
        <!-- listreservations may become deprecated? -->
        <golf-reservations-list-modal />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResourceCommentModal from '../common/ResourceCommentModal.vue'
import GolfTableColumn from './GolfTableColumn.vue'
import GolfConfirmationModal from './GolfConfirmationModal.vue'
import GolfReservationsListModal from './GolfReservationsListModal.vue'
import EditGolfReservationModal from './EditGolfReservationModal.vue'
import GolfReservationsUserModal from './GolfReservationsUserModal.vue'
import GolfAdminReservationListModal from './GolfAdminReservationListModal.vue'
import GolfStickyNotes from './GolfStickyNotes.vue'

const { formatDateTime, dateFormat, getDateFormat } = window.wisenetwork;

export default {
    components: {
        GolfTableColumn,
        GolfConfirmationModal,
        GolfReservationsListModal,
        EditGolfReservationModal,
        GolfReservationsUserModal,
        ResourceCommentModal,
        GolfAdminReservationListModal,
        GolfStickyNotes,
    },
    data() {
        return {
            selectedResource: 0,
            showPast: false,
        }
    },
    computed: {
        ...mapGetters({
            VIEW_MODES: 'golf/VIEW_MODES',
            selectedViewMode: 'golf/selectedViewMode',
            showStickyNotes: 'golf/showStickyNotes',
            date: 'reservations/date',
            dateChangeInProgress: 'reservations/dateChangeInProgress',
            isInvalidDate: 'reservations/isInvalidDate',
            activeReservation: 'calendar/activeReservation',
            timeTable: 'calendar/timeTable',
            baseTimeTable: 'calendar/baseTimeTable',
            product: 'ecom/product',
            admin: 'common/admin',
            adminMode: 'common/adminMode',
            mobile: 'common/mobile',
            disabled: 'reservations/disabled',
            dateRestrictions: 'reservations/dateRestrictions',
        }),
        timeTableRows() {
            return this.timeTable;
        },
        selectedTable() {
            return this.timeTable.filter(row => row.resourceId === this.selectedResource)[0] || { title:'' };
        },
        isToday() {
            return this.date.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');
        },
    },
    methods: {
        onDeselectAll() {
            this.$refs.golfTableColumn.forEach(elem => elem.deselectAll());
        },
        toggleAdminMode() {
            this.$store.commit('common/toggleAdminMode')
            this.$store.commit('reservations/setServiceAdminMode', this.adminMode);
            
            this.$store.dispatch('reservations/onDateChange', this.date)
                .then(() => {
                    this.$emit('adminToggle')
                })
        },
        adjustDate(value) {
            const input = this.$refs.dateInput;
            const picker = input._daterangepicker
            const date = this.date.clone().add(value, 'days');
            
            if (!!picker) {
                picker.setStartDate(date);
                picker.setEndDate(date);
            } else {
                //this.initDatepicker(date);
            }
            
            this.$store.dispatch('reservations/onDateChange', date);
        },
        initDatepicker() {
            const { daterangepicker } = window.wisenetwork
            const input = this.$refs.dateInput;
            const dayNameShort = getDateFormat(dateFormat.DATETIME_DAY_NAME_SHORT);
            const dayFormat = getDateFormat(dateFormat.DATETIME_DMY);
            const format = this.weekMode ? `[${ _locale('week').ucfirst() }] w` : dayNameShort+' '+dayFormat;
            const startDate = this.$store.getters['reservations/startDate'];
            
            let date = this.date
            
            if (startDate > date) {
                date = startDate;
            }

            if (this.mobile) {
                input.readOnly = true;
            }
            
            const picker = daterangepicker(
                input,
                {
                    locale: { 
                        format,
                        daysOfWeek: _localeDates.dayNamesMin,
                        monthNames: _localeDates.monthNamesShort,
                        firstDay: 1,
                    },
                    opens: 'right',
                    showWeekNumbers: true,
                    singleDatePicker: true,
                    showDropdowns: true,
                    startDate: date,
                    isInvalidDate: (date) => this.isInvalidDate(date)
                }, 
                (startDate, endDate) => {
                    this.$store.dispatch('reservations/onDateChange', startDate)
                }
            )

            if (moment().format('YYYY-MM-DD') !== date.format('YYYY-MM-DD')) {
                const toggleFocus = (pulse) => {
                    if (pulse <= 0) return;

                    if (input.classList.contains('input-focus')) {
                        input.classList.remove('input-focus')
                    } else {
                        input.classList.add('input-focus')
                    }

                    setTimeout(() => toggleFocus(pulse - 1), 600)
                }

                setTimeout(() => toggleFocus(6), 600)
            }
        },
        openGolfUserTeeTimes() {
            this.$store.commit('common/setModal', 'usergolfreservations')
            this.$store.commit('common/setModalClass', 'modal-lg')
        },
        openAdminTeeTimes() {
            this.$store.commit('common/setModal', 'admingolfreservations')
            this.$store.commit('common/setModalClass', 'modal-lg')
        },
    },
    mounted() {        
        this.$nextTick(() => {
            this.initDatepicker()
            this.selectedResource = this.timeTable[0].resourceId
        })
        
        // trigger to get user player information
        this.$store.dispatch('golf/getPlayerInformation');
        this.$store.dispatch('golf/getClubInformation');
    }
}
</script>

<style lang="scss">
.fadeInBottom-enter-active, .fadeInBottom-leave-active {
    transition: opacity .3s;
}
.fadeInBottom-enter, .fadeInBottom-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.input-focus {
    border-color: #66afe9;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
}
</style>